<ion-content>
  <div class="py-4">
    <ion-list lines="none">
      <ion-item class="pointer-hover py-1 px-4" (click)="select(0)">
        <div slot="start">
          <div [class.color-primary]="value === 0">
            <i class="fa-kit fa-picto-horlogeete fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00058.card.status.ete' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00058.autoModal.eteDescription' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 0) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>
      <ion-item class="pointer-hover py-1 px-4" (click)="select(1)">
        <div slot="start">
          <div [class.color-primary]="value === 1">
            <i class="fa-kit fa-picto-horlogehiver fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00058.card.status.hiver' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00058.autoModal.hiverDescription' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 1) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>
      <ion-item class="pointer-hover py-1 px-4" (click)="select(2)">
        <div slot="start">
          <div [class.color-primary]="value === 2">
            <i class="fa-kit fa-picto-horloge72h fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00058.card.status.72h' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00058.autoModal.72hDescription' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 2) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>
      <ion-item class="pointer-hover py-1 px-4" (click)="select(3)">
        <div slot="start">
          <div [class.color-primary]="value === 3">
            <i class="fa-kit fa-vs-v2 fs-28"></i>
          </div>
        </div>
        <ion-label>
          <div>
            <div class="h5 mb-1">
              {{ 'P00058.card.status.baignade' | translate }}
            </div>
            <div class="color-medium">
              {{ 'P00058.autoModal.baignadeDescription' | translate }}
            </div>
          </div>
        </ion-label>

        @if (value === 3) {
          <div slot="end" class="color-primary">
            <i class="fa-regular fa-check"></i>
          </div>
        }
      </ion-item>
    </ion-list>
  </div>
</ion-content>

<ion-footer>
  <div class="p-3">
    <div class="row">
      <div class="col-12 text-center">
        <ion-button
          expand="block"
          fill="outline"
          color="medium"
          (click)="dismissModal()"
        >
          {{ 'selectTimeInterval.cancel' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-footer>
